import React from 'react';
import styled from 'styled-components';
import { vw } from 'components/common/Common';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

const Section = styled.section`
  width: 100%;
  background: #f4f6fc;
  border-radius: ${vw(2)};
  padding: ${vw(24)};
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${vw(24)};
  min-height: 340px;
`;

const Left = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${vw(12)};
`;

const Title = styled.h2`
  margin: 0;
  font-size: 40px;
  font-weight: 600;
  color: #050a30;
  line-height: normal;
`;

const Paragraph = styled.p`
  margin: 0;
  font-size: 16px;
  color: #424748;
  line-height: 1.3;
`;

const Right = styled.div`
  background: #ffffff;
  border-radius: ${vw(2)};
  padding: ${vw(24)};
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(${vw(120)}, 1fr));
  justify-items: center;
  align-items: center;
  gap: ${vw(24)};
`;

const RightSpecial = styled.div`
  background: #ffffff;
  border-radius: ${vw(2)};
  padding: ${vw(24)} ${vw(130)};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const IconBubble = styled.div`
  width: ${vw(120)};
  height: ${vw(120)};
  border-radius: 50%;
  background: ${(props) => props.$bgColor || '#1f68db'};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const IconImg = styled.img`
  width: ${vw(56)};
  height: ${vw(56)};
  object-fit: contain;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 80px;
  max-width: 400px;
`;

const IconFeatureBlocks = () => {
  return (
    <Container>
      <Section>
        <Left>
          <Title>All-Inclusive Private Jet Card: No Hidden Fees</Title>
          <Paragraph>
            Our private jet card offers a straightforward, all-inclusive pricing structure. Enjoy
            the freedom of luxury travel without upfront deposits or hidden fees. We cover all
            expenses, including fuel, repositioning, and taxi time, providing a seamless and
            transparent experience.
          </Paragraph>
        </Left>
        <Right>
          <IconBubble>
            <IconImg src="/imgs/svg/jetCard/no-fees.svg" alt="no fees" />
          </IconBubble>
          <IconBubble>
            <IconImg src="/imgs/svg/jetCard/plane-car.svg" alt="ground transfers" />
          </IconBubble>
          <IconBubble>
            <IconImg src="/imgs/svg/jetCard/ticket-sale-bold.svg" alt="transparent pricing" />
          </IconBubble>
        </Right>
      </Section>

      <Section>
        <Left>
          <Title>Flexible and Secure Payment Solutions for Jet Card Members</Title>
          <Paragraph>
            Our payment process accommodates your preferences with options including wire transfers,
            credit card transactions, and cryptocurrency like Bitcoin and Ethereum, processed
            securely through Coinbase. Funds are stored in secure, non-operational bank accounts
            safeguarding your funds for flight services. We ensure full transparency in pricing,
            eliminating hidden charges and providing a clear breakdown of all costs.
          </Paragraph>
        </Left>
        <RightSpecial>
          <Row style={{ alignSelf: 'flex-start' }}>
            <IconBubble $bgColor="#f4f6fc">
              <IconImg src="/imgs/svg/jetCard/bank-transfer.svg" alt="bank transfers" />
            </IconBubble>
            <IconBubble $bgColor="#f4f6fc">
              <IconImg src="/imgs/svg/jetCard/credit-card.svg" alt="credit card payments" />
            </IconBubble>
          </Row>

          <Row style={{ alignSelf: 'flex-end' }}>
            <IconBubble $bgColor="#f4f6fc">
              <IconImg
                src="/imgs/svg/jetCard/ethereum.svg"
                alt="cryptocurrency payments with Ethereum using Coinbase"
              />
            </IconBubble>
            <IconBubble $bgColor="#f4f6fc">
              <IconImg
                src="/imgs/svg/jetCard/pay.svg"
                alt="pay for your private jet with bitcoin cryptocurrency"
              />
            </IconBubble>
          </Row>
        </RightSpecial>
      </Section>
    </Container>
  );
};

export default IconFeatureBlocks;
